import React from "react";
import { Link } from "react-scroll";
import { Parallax } from "react-parallax";
import { scrollDuration } from "../config/commonConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLaravel,
  faPhp,
  faReact,
  faLinux,
  faGitAlt,
  faJs,
} from "@fortawesome/free-brands-svg-icons";
import T from "./Translate/T";
import "./CallToAction.scss";

// Custom SVG icons for TypeScript and Next.js
const TypeScriptIcon = () => (
  <svg viewBox="0 0 128 128" width="45" height="45">
    <path fill="#3178c6" d="M2 63.91v62.5h125v-125H2zm100.73-5a15.56 15.56 0 017.82 4.5 20.58 20.58 0 013 4c0 .16-5.4 3.81-8.69 5.85-.12.08-.6-.44-1.13-1.23a6.55 6.55 0 00-5.77-3.22c-3.71-.18-6.12 1.88-6.1 5.18a4.49 4.49 0 00.49 2.43c.67 1.31 1.93 2.11 6.11 3.91 7.72 3.31 11 5.36 13.2 8.2a15.24 15.24 0 011.65 12.62 16.39 16.39 0 01-13.63 11.13 39.56 39.56 0 01-9.78-.18 23.09 23.09 0 01-11.29-5.74 21.35 21.35 0 01-3.43-5.18c.22-.15 1-.71 1.73-1.22l5.63-3.25 1.82-1.05.36.6a12.63 12.63 0 004.7 4.48c4.3 2.05 10.24 1.43 12.4-1.28a5.11 5.11 0 00.38-5.58c-.76-1.27-2.33-2.31-7-4.42-5.35-2.42-7.65-3.92-9.62-6.27a14.06 14.06 0 01-2.42-8.09 14.15 14.15 0 014-10.44 17.1 17.1 0 0112.16-4.85 24.42 24.42 0 019.57 1.68zM73 65.54V71h-15v45.39H46.78V71H32v-5.4a51.23 51.23 0 01.12-5.61c.06-.06 9.27-.08 20.45-.05L73 60z"/>
  </svg>
);

const NextJsIcon = () => (
  <svg viewBox="0 0 128 128" width="45" height="45">
    <path fill="#fff" d="M64 0C28.7 0 0 28.7 0 64s28.7 64 64 64c11.2 0 21.7-2.9 30.8-7.9L48.4 55.3v36.6h-6.8V41.8h6.8l50.5 75.8C116.4 106.2 128 86.5 128 64c0-35.3-28.7-64-64-64zm22.1 84.6l-7.5-11.3V41.8h7.5v42.8z"/>
  </svg>
);

const CallToAction = () => {
  return (
    <section>
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />
        <Parallax
          bgImage="images/intro-bg-2.jpg"
          bgImageAlt="Intro"
          strength={200}
        >
          <div className="hero-content section">
            <div className="container py-5 wow fadeInUp">
              <div className="cta-content">
                <h2 className="text-10 fw-600 text-white mb-4 text-center">
                  <T>Interested in working with me?</T>
                </h2>
                
                <div className="cube-wrapper">
                  <div className="cubespinner">
                    <div className="face1">
                      <FontAwesomeIcon icon={faLaravel} />
                    </div>
                    <div className="face2">
                      <FontAwesomeIcon icon={faPhp} />
                    </div>
                    <div className="face3">
                      <TypeScriptIcon />
                    </div>
                    <div className="face4">
                      <FontAwesomeIcon icon={faReact} />
                    </div>
                    <div className="face5">
                      <NextJsIcon />
                    </div>
                    <div className="face6">
                      <FontAwesomeIcon icon={faGitAlt} />
                    </div>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Link
                    className="btn btn-primary rounded-0 smooth-scroll wow rubberBand"
                    data-wow-delay="1s"
                    smooth="easeInOutQuint"
                    duration={scrollDuration}
                    to="contact"
                  >
                    <T>Hire Me!</T>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Parallax>
      </div>
    </section>
  );
};

export default CallToAction;